/// <reference types="node" />
import BigNumber from 'bignumber.js'

export const halfEven = function (number: any, n = 2) {
  BigNumber.set({ ROUNDING_MODE: 6 })
  return Number(new BigNumber(number).toFixed(n))
}

export const halfUp = function (number: any, n = 2) {
  BigNumber.set({ ROUNDING_MODE: 4 })
  return Number(new BigNumber(number).toFixed(n))
}

export const alwaysDown = function (number: any, n = 2) {
  BigNumber.set({ ROUNDING_MODE: 1 })
  return Number(new BigNumber(number).toFixed(n))
}

export const alwaysUp = function (number: any, n = 2) {
  BigNumber.set({ ROUNDING_MODE: 0 })
  return Number(new BigNumber(number).toFixed(n))
}

export const plus = function (x: any, y: any, n = 7) {
  BigNumber.set({ ROUNDING_MODE: 4 })
  return Number(new BigNumber(x).plus(y).toFixed(n))
}

export const minus = function (x: any, y: any, n = 7) {
  BigNumber.set({ ROUNDING_MODE: 4 })
  return Number(new BigNumber(x).minus(y).toFixed(n))
}

export const div = function (x: any, y: any, n = 7) {
  BigNumber.set({ ROUNDING_MODE: 4 })
  return Number(new BigNumber(x).div(y).toFixed(n))
}

export const times = function (x: any, y: any, n = 7) {
  BigNumber.set({ ROUNDING_MODE: 4 })
  return Number(new BigNumber(x).times(y).toFixed(n))
}

export const BigNumberStatic = function (x: any) {
  BigNumber.set({ ROUNDING_MODE: 4 })
  return new BigNumber(x)
}
